import { Component } from '@angular/core';
import { RecentChatService } from '../core/services/recent-chats.service';
import { EmployeeService } from '../core/services/employee.service';
import { AuthService } from '../core/services/auth.service';
import { OrderService } from '../core/services/order.service';
import { Order } from '../core/models/order';
import { Employee } from '../core/models/employee';
import { RecentChat } from '../core/models/recent_chats';

@Component({
  selector: 'app-tabs',
  templateUrl: 'tabs.page.html',
  styleUrls: ['tabs.page.scss']
})
export class TabsPage {
  memberChatCount$: number = 0;
  orderChatCount$: number = 0;
  uid;

  constructor(
    private employeeService: EmployeeService,
    private authService: AuthService,
    private orderService: OrderService,
    private recentchatsService: RecentChatService,
  ) { 
    this.getOrderMessages();
    this.getMemberMessages();
  }
  getOrderMessages() {
    this.authService.getCurrentUser()
      .then((res: firebase.User) => {
        this.uid = res.uid
        this.orderService.getChatsByOrder('assigned_employee', res.uid).subscribe((ordRes: Order[]) => {
          if (ordRes.length) {
            this.orderChatCount$ = ordRes.filter((result: Order) => {
              if (result.chat !== null && result.chat !== undefined) {
                if (result.chat.read_by && result.chat.read_by.includes(this.uid)) {
                  return null;
                }
                else {
                  return result;
                }
              }
              else {
                return null;
              }      
            }).length
          }
        })
      })
  }
  getMemberMessages() {
    this.authService.getCurrentUser()
      .then((res: firebase.User) => {
        // this.employeeService.employeeById(res.uid).subscribe((empRes: Employee) => {
          // const empRes = this.employeeService.employee
          // if (empRes.location_ids && Object.keys(empRes.location_ids).length) {
            this.recentchatsService.chatByLocation(this.employeeService.defaultLocation).subscribe(chatRes => {
              if (chatRes.length) {
                this.memberChatCount$ = chatRes.filter((result: RecentChat) => {
                  return !(result.read_by && result.read_by.includes(this.uid))
                }).length
              }
            })
          // }
        })
      // })
  }

}
